import { Navigate, Outlet } from "react-router-dom";
import { useStateContext } from "../../contexts/ContextProvider";
import Loader from "../dataDisplay/Loader";

/**
 * Garde de l'espace hôtelier.
 *
 * Le vrai verrou est côté serveur (`EnsureHotelierBoundary`) : celui-ci évite
 * seulement d'afficher un écran vide à un compte qui n'a rien à y faire.
 *
 * Le super-admin passe, comme côté API, pour pouvoir constater ce que voit un
 * client.
 */
export default function RequireHotelier() {
    const { token, user, isUserLoading } = useStateContext();

    if (!token) return <Navigate to="/login" replace />;

    // `isUserLoading` ne suffit pas : il vaut `false` avant même que la
    // requête de profil ne parte, et la garde tranchait alors sur un
    // utilisateur vide. Toute sous-route ouverte directement — un lien
    // partagé, un rafraîchissement — rebondissait vers l'accueil, l'adresse
    // demandée perdue en chemin. `user.id === 0` est le marqueur du profil
    // pas encore résolu, comme dans `SmartRedirect`.
    if (isUserLoading || user.id === 0) {
        return <Loader message="chargement" useNeutralLoader={true} />;
    }

    if (!user.is_hotelier && !user.is_super_admin) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
}
